import { FolderNodeSavePermission, IFolderNodeSavePermission } from "./folderNodePermission";

export interface IFolderNodeSave {
    id: string;
    permissions: IFolderNodeSavePermission[];
}

export class FolderNodeSave implements IFolderNodeSave {
    id: string;
    permissions: FolderNodeSavePermission[];

    constructor();
    constructor(obj: IFolderNodeSave);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.permissions = [];
        if (obj && obj.permissions) {
            for (let i = 0; i < obj.permissions.length; i++) {
                this.permissions.push(new FolderNodeSavePermission(obj.permissions[i]));
            }
        }
    }

    static getSortedJsonFolderNodeSaves(src: IFolderNodeSave[]): IFolderNodeSave[] {
        const result = src.slice(0);
        result.sort((a: IFolderNodeSave, b: IFolderNodeSave) => {
            if ((a === null || a === undefined) && (b === null || b === undefined)) return 0;
            if (a === null || a === undefined) return 1;
            if (b === null || b === undefined) return -1;
            if ((a.id === null || a.id === undefined) && (b.id === null || b.id === undefined)) return 0;
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
        });
        return result;
    }
}